var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70 43.75V23.8C70 17.9194 70 14.9792 68.8556 12.7331C67.8489 10.7574 66.2426 9.1511 64.2669 8.14443C62.0208 7 59.0805 7 53.2 7H30.8C24.9194 7 21.9792 7 19.7331 8.14443C17.7574 9.1511 16.1511 10.7574 15.1444 12.7331C14 14.9792 14 17.9194 14 23.8V60.2C14 66.0805 14 69.0208 15.1444 71.2669C16.1511 73.2426 17.7574 74.8489 19.7331 75.8556C21.9792 77 24.9194 77 30.8 77H42M49 38.5H28M35 52.5H28M56 24.5H28M50.75 66.5L57.75 73.5L73.5 57.75",
    stroke: "#FEFEFE",
    strokeWidth: 4.34483,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.6c4cdf36324a756cce659213d3921bb7.svg";
export { ForwardRef as ReactComponent };